import { isPatron, scrollToTop } from "util";

import classNames from "classnames";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

//import Ad from './Ad'
//import AlertDismissible from './AlertDismissable'
import ErrorBoundary from "components/ErrorBoundary";
import GoogleAnalytics from "components/GoogleAnalytics";
import AlternateArtModal from "components/Modals/AlternateArtModal";
import ScrollToTopButton from "components/ScrollToTopButton";
import Toasts from "components/Toasts";
import { fetchMisc } from "store/misc";

import Footer from "./Footer";
import styles from "./Layout.module.scss";
import Leaderboard from "./Leaderboard";
import Navbar from "./Navbar";

const Layout = () => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.firebase.profile);
  const location = useLocation();
  const history = useNavigate();
  const [prevLocation, setPrevLocation] = useState(location);

  useEffect(() => {
    dispatch(fetchMisc());
    scrollToTop();
  }, []);

  useEffect(() => {
    if (
      location.pathname !== prevLocation?.pathname ||
      location.search !== prevLocation?.search ||
      location.hash !== prevLocation?.hash
    ) {
      if (!location.state?.noTop) {
        scrollToTop();
      }
      dispatch({ history, location, prevLocation, type: "LOCATION_CHANGE" });
      setPrevLocation(location);
    }
  }, [location]);

  return (
    <div className={styles.containerOuter}>
      <div className={classNames(styles.container, styles.background)}>
        <ErrorBoundary>
          <AlternateArtModal />
        </ErrorBoundary>
        <GoogleAnalytics />
        <ScrollToTopButton />
        <Toasts />
        <Navbar />
        <div className={styles.containerInner}>
          <ErrorBoundary>
            {/*<AlertDismissible />*/}
            {isPatron(profile) || (
              <>
                <Leaderboard />
                <Helmet>
                  <script
                    type="text/javascript"
                    async="async"
                    data-noptimize="1"
                    data-cfasync="false"
                    src="//scripts.mediavine.com/tags/edhrec.js"
                  ></script>
                </Helmet>
              </>
            )}
            <div className={classNames(styles.background)}>
              <div className={styles.layout}>
                <div className={styles.left}>
                  <Outlet />
                </div>
              </div>
            </div>
          </ErrorBoundary>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Layout;
